import useFetchAllProperties from 'components/domain/property/useFetchAllProperties';
import useFetchIntegrationPropertySettings from 'hooks/useFetchIntegrationPropertySettings';
import {
  IntegrationEnum,
  IntegrationStatus,
} from 'models/InternalIntegrationSetting';
import { PROPERTY_STATUS } from 'models/Properties';
import { API_MAX_LIMIT } from 'services/API.constants';
import getPropertiesQuery from 'utils/property/getPropertiesQuery';

/**
 * Tells if the agency has at least one property enabled with Hostfully Assist.
 */
const useHasHostfullyAssistEnabledProperties = () => {
  const { allProperties, isFetching: isFetchingProperties } =
    useFetchAllProperties({
      enabled: true,
      conditions: getPropertiesQuery({
        filters: {
          limit: API_MAX_LIMIT,
          status: PROPERTY_STATUS.ACTIVE,
          topLevelOnly: true,
        },
      }),
      fields: 'uid',
      operationName: 'InboxAssistEnrollmentCheck',
    });

  const propertyUids = allProperties?.map(({ uid }) => uid) ?? [];

  const { data, isInitialLoading: isFetchingSettings } =
    useFetchIntegrationPropertySettings({
      enumId: IntegrationEnum.HOSTFULLYASSIST,
      propertyUids,
      enabled: !isFetchingProperties && propertyUids.length > 0,
    });

  const hasHostfullyAssistEnabledProperties = Boolean(
    data?.propertySettings.some(
      (property) => property.status === IntegrationStatus.ACTIVE,
    ),
  );

  const isLoading =
    isFetchingProperties || (propertyUids.length > 0 && isFetchingSettings);

  return { hasHostfullyAssistEnabledProperties, isLoading };
};

export default useHasHostfullyAssistEnabledProperties;
